const ROSTER_TAB = '[data-tour="shift-and-roster-roster"]';
const ADD_BTN = '[data-tour="shift-and-roster-add-roster-button"]';
const STEP1 = '[data-tour="shift-and-roster-add-roster-step1"]';
const STEP1_NEXT = '[data-tour="shift-and-roster-add-roster-step1-next-button"]';
const STEP2 = '[data-tour="shift-and-roster-add-roster-step2"]';
const STEP2_DOLATER = '[data-tour="shift-and-roster-add-roster-step2-do-later-button"]';
const STEP2_CONFIRM = '[data-tour="shift-and-roster-add-roster-step2-confirm-button"]';
const ROSTER_DATA = '[data-tour="shift-and-roster-roster-data"]';
const EDIT_ROSTER = '[data-tour="shift-and-roster-edit-roster"]';
const EDIT_ROSTER_INPUT = '[data-tour="shift-and-roster-edit-roster-input"]';
const DELETE_ROSTER = '[data-tour="shift-and-roster-delete-roster"]';
const DETAIL = '[data-tour="shift-and-roster-detail"]';
const FILTER_INPUT = '[data-tour="shift-and-roster-filter-input"]';
const ADD_USER_BTN = '[data-tour="shift-and-roster-add-user-button"]';
const ADD_USER_INPUT = '[data-tour="shift-and-roster-add-user-input"]';
const ADD_ROSTERITEM = '[data-tour="shift-and-roster-add-rosteritem"]';
const ADD_ROSTERITEM_INPUT = '[data-tour="shift-and-roster-add-rosteritem-input"]';
const TABLE = '[data-tour="shift-and-roster-table"]';
const ADD_ROSTERITEM_TABLE = '[data-tour="shift-and-roster-add-rosteritem-table"]';
const ADD_REQUEST = '[data-tour="shift-and-roster-add-request"]';
const ADD_REQUEST_INPUT = '[data-tour="shift-and-roster-add-request-input"]';
const EDIT_ITEM = '[data-tour="shift-and-roster-edit-item"]';
const EDIT_ITEM_INPUT = '[data-tour="shift-and-roster-edit-item-input"]';
const DELETE_ITEM = '[data-tour="shift-and-roster-delete-item"]';
const SHIFT_TAB = '[data-tour="shift-and-roster-shift"]';
const ADD_SHIFT_BTN = '[data-tour="shift-and-roster-add-shift-button"]';
const ADD_SHIFT_STEP1 = '[data-tour="shift-and-roster-add-shift-step1"]';
const ADD_SHIFT_STEP1_NEXT = '[data-tour="shift-and-roster-add-shift-step1-next-button"]';
const ADD_SHIFT_STEP2 = '[data-tour="shift-and-roster-add-shift-step2"]';
const ADD_SHIFT_STEP2_BREAK = '[data-tour="shift-and-roster-add-shift-step2-break-time"]';
const ADD_SHIFT_STEP2_DOLATER = '[data-tour="shift-and-roster-add-shift-step2-do-later-button"]';
const ADD_SHIFT_STEP2_NEXT = '[data-tour="shift-and-roster-add-shift-step2-next-button"]';
const ADD_SHIFT_STEP3 = '[data-tour="shift-and-roster-add-shift-step3"]';
const ADD_SHIFT_STEP3_DOLATER = '[data-tour="shift-and-roster-add-shift-step3-do-later-button"]';
const ADD_SHIFT_STEP3_CONFIRM = '[data-tour="shift-and-roster-add-shift-step3-confirm-button"]';
const ADD_SHIFT_TABLE = '[data-tour="shift-and-roster-add-shift-table"]';
const ADD_SHIFT_EDIT = '[data-tour="shift-and-roster-add-shift-edit-button"]';
const ADD_SHIFT_DELETE = '[data-tour="shift-and-roster-add-shift-delete-button"]';
const REQUEST_TAB = '[data-tour="shift-and-roster-request"]';
const REQUEST_FILTER = '[data-tour="shift-and-roster-request-filter"]';
const REQUEST_CALENDAR = '[data-tour="shift-and-roster-request-calendar"]';
const REQUEST_CHART = '[data-tour="shift-and-roster-request-chart"]';
const REQUEST_TABLE = '[data-tour="shift-and-roster-request-table"]';

const waitForWindowFn = (name, timeout = 2500) =>
  new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      if (typeof window[name] === "function") {
        resolve(window[name]);
        return;
      }
      if (Date.now() - start >= timeout) {
        reject(new Error(`${name} not ready`));
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });

/** Gọi handler sau khi view remount (list ↔ detail) */
const callWhenReady = async (name) => {
  try {
    const fn = await waitForWindowFn(name);
    fn();
  } catch (e) {
    console.warn(e);
  }
};

/** Đóng hết dialog/menu rồi về tab Rosters (list) */
const resetToRosterList = () => {
  window.__closeAddRosterDialog?.();
  window.__closeAddShiftDialog?.();
  window.__closeTourEditRosterDialog?.();
  window.__closeTourDeleteRosterDialog?.();
  window.__closeTourAddUserRoster?.();
  window.__closeTourAddRosterItems?.();
  window.__closeTourAddRequestDialog?.();
  window.__closeTourEditRosterItemDialog?.();
  window.__closeTourDeleteRosterItemDialog?.();
  window.__closeTourRosterDetail?.();
  window.__setShiftAndRosterTab?.(0);
};

const goToRosterTab = async () => {
  resetToRosterList();
  await callWhenReady("__setShiftAndRosterTab");
  window.__setShiftAndRosterTab?.(0);
};

const openAddRosterStep1 = async () => {
  resetToRosterList();
  await callWhenReady("__openAddRosterDialog");
  await callWhenReady("__goAddRosterStep1");
};

const openAddRosterStep2 = async () => {
  resetToRosterList();
  await callWhenReady("__openAddRosterDialog");
  await callWhenReady("__goAddRosterStep2");
};

const showRosterData = async () => {
  resetToRosterList();
  await callWhenReady("__enableTourFakeRoster");
};

const openEditRosterMenu = async () => {
  resetToRosterList();
  // Chờ Rosters remount sau khi rời detail rồi mới mở menu
  await callWhenReady("__openTourRosterEditMenu");
};

const openEditRosterDialog = async () => {
  resetToRosterList();
  await callWhenReady("__openTourEditRosterDialog");
};

const openRosterDetail = async () => {
  window.__closeAddRosterDialog?.();
  window.__closeTourEditRosterDialog?.();
  window.__closeTourDeleteRosterDialog?.();
  window.__closeTourAddUserRoster?.();
  window.__closeTourAddRosterItems?.();
  window.__closeTourAddRequestDialog?.();
  window.__closeTourEditRosterItemDialog?.();
  window.__closeTourDeleteRosterItemDialog?.();
  window.__openTourRosterDetail?.();
  // Chờ detail view mount (handler nằm trong ShiftAndRosterView)
  await waitForWindowFn("__openTourAddUserRoster").catch(() => null);
};

/** Đóng dialog detail rồi hiện lại toolbar/table (Prev từ dialog về button) */
const openDetailToolbar = async () => {
  await openRosterDetail();
  window.__closeTourAddUserRoster?.();
  window.__closeTourAddRosterItems?.();
  window.__closeTourAddRequestDialog?.();
  window.__closeTourEditRosterItemDialog?.();
  window.__closeTourDeleteRosterItemDialog?.();
};

const openAddUserRoster = async () => {
  await openRosterDetail();
  window.__openTourAddUserRoster?.();
};

const openAddRosterItems = async () => {
  await openRosterDetail();
  window.__closeTourAddUserRoster?.();
  await callWhenReady("__openTourAddRosterItems");
};

const openClassicItemMenu = async () => {
  await openDetailToolbar();
  await callWhenReady("__openTourClassicItemMenu");
};

const openAddRequestDialog = async () => {
  await openRosterDetail();
  await callWhenReady("__openTourAddRequestDialog");
};

const openEditItemDialog = async () => {
  await openRosterDetail();
  await callWhenReady("__openTourEditRosterItemDialog");
};

const openDeleteItemDialog = async () => {
  await openRosterDetail();
  await callWhenReady("__openTourDeleteRosterItemDialog");
};

const openAddCellPlus = async () => {
  await openDetailToolbar();
  await callWhenReady("__openTourAddRosterItemFromCell");
};

/** Tab Shifts */
const goToShiftsTab = async () => {
  resetToRosterList();
  await callWhenReady("__setShiftAndRosterTab");
  window.__setShiftAndRosterTab?.(1);
};

/** Mở dialog Add Shift ở step cụ thể (0/1/2) + fake dữ liệu bắt buộc */
const openAddShiftStep = async (step) => {
  await goToShiftsTab();
  await callWhenReady("__openAddShiftDialog");
  window.__openAddShiftDialog?.();
  await callWhenReady("__goAddShiftStep");
  window.__goAddShiftStep?.(step);
};

/** Bảng shift + fake row để highlight Edit/Delete */
const showShiftTable = async () => {
  await goToShiftsTab();
  window.__closeAddShiftDialog?.();
  await callWhenReady("__enableTourFakeShift");
  window.__enableTourFakeShift?.();
};

/** Tab Request (đóng dialog shift + mở Summary) */
const goToRequestTab = async () => {
  resetToRosterList();
  window.__closeAddShiftDialog?.();
  await callWhenReady("__setShiftAndRosterTab");
  window.__setShiftAndRosterTab?.(2);
  await callWhenReady("__expandTourRequestSummary");
  window.__expandTourRequestSummary?.();
};

/** Steps dành cho admin (có nút Add Roster + dialog) */
const getAdminSteps = (t) => [
  {
    selector: ADD_BTN,
    content: t("tour.shift-and-roster.add-roster-button"),
    tourOpen: goToRosterTab,
    tourWaitFor: ADD_BTN,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
    adminOnly: true,
  },
  {
    selector: STEP1,
    content: t("tour.shift-and-roster.add-roster-step1"),
    tourOpen: openAddRosterStep1,
    tourWaitFor: STEP1,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP1],
    resizeObservables: [STEP1],
    adminOnly: true,
  },
  {
    selector: STEP1_NEXT,
    content: t("tour.shift-and-roster.add-roster-step1-next-button"),
    tourOpen: openAddRosterStep1,
    tourWaitFor: STEP1_NEXT,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: STEP2,
    content: t("tour.shift-and-roster.add-roster-step2"),
    tourOpen: openAddRosterStep2,
    tourWaitFor: STEP2,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP2],
    resizeObservables: [STEP2],
    adminOnly: true,
  },
  {
    selector: STEP2_DOLATER,
    content: t("tour.shift-and-roster.add-roster-step2-do-later-button"),
    tourOpen: openAddRosterStep2,
    tourWaitFor: STEP2_DOLATER,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    adminOnly: true,
  },
  {
    selector: STEP2_CONFIRM,
    content: t("tour.shift-and-roster.add-roster-step2-confirm-button"),
    tourOpen: openAddRosterStep2,
    tourWaitFor: STEP2_CONFIRM,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    adminOnly: true,
  },
  {
    selector: EDIT_ROSTER,
    content: t("tour.shift-and-roster.edit-roster"),
    tourOpen: openEditRosterMenu,
    tourWaitFor: EDIT_ROSTER,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EDIT_ROSTER],
    resizeObservables: [EDIT_ROSTER],
    adminOnly: true,
  },
  {
    selector: EDIT_ROSTER_INPUT,
    content: t("tour.shift-and-roster.edit-roster-input"),
    tourOpen: openEditRosterDialog,
    tourWaitFor: EDIT_ROSTER_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EDIT_ROSTER_INPUT],
    resizeObservables: [EDIT_ROSTER_INPUT],
    adminOnly: true,
  },
  {
    selector: DELETE_ROSTER,
    content: t("tour.shift-and-roster.delete-roster"),
    // Highlight MenuItem Delete → phải mở menu, không mở dialog
    tourOpen: openEditRosterMenu,
    tourWaitFor: DELETE_ROSTER,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [DELETE_ROSTER],
    resizeObservables: [DELETE_ROSTER],
    adminOnly: true,
  },
  {
    selector: DETAIL,
    content: t("tour.shift-and-roster.detail"),
    tourOpen: openRosterDetail,
    tourWaitFor: DETAIL,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [DETAIL],
    resizeObservables: [DETAIL],
  },
  {
    selector: FILTER_INPUT,
    content: t("tour.shift-and-roster.filter-input"),
    tourOpen: openDetailToolbar,
    tourWaitFor: FILTER_INPUT,
    tourWaitFrames: 1,
  },
  {
    selector: ADD_USER_BTN,
    content: t("tour.shift-and-roster.add-user-button"),
    tourOpen: openDetailToolbar,
    tourWaitFor: ADD_USER_BTN,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_USER_INPUT,
    content: t("tour.shift-and-roster.add-user-input"),
    tourOpen: openAddUserRoster,
    tourWaitFor: ADD_USER_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_USER_INPUT],
    resizeObservables: [ADD_USER_INPUT],
  },
  {
    selector: ADD_ROSTERITEM,
    content: t("tour.shift-and-roster.add-rosteritem"),
    tourOpen: openDetailToolbar,
    tourWaitFor: ADD_ROSTERITEM,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_ROSTERITEM_INPUT,
    content: t("tour.shift-and-roster.add-rosteritem-input"),
    tourOpen: openAddRosterItems,
    tourWaitFor: ADD_ROSTERITEM_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_ROSTERITEM_INPUT],
    resizeObservables: [ADD_ROSTERITEM_INPUT],
  },
  {
    selector: TABLE,
    content: t("tour.shift-and-roster.table"),
    tourOpen: openDetailToolbar,
    tourWaitFor: TABLE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
  {
    selector: ADD_ROSTERITEM_TABLE,
    content: t("tour.shift-and-roster.add-rosteritem-table"),
    tourOpen: openAddCellPlus,
    tourWaitFor: ADD_ROSTERITEM_TABLE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    adminOnly: true,
  },
  {
    selector: ADD_REQUEST,
    content: t("tour.shift-and-roster.add-request"),
    tourOpen: openClassicItemMenu,
    tourWaitFor: ADD_REQUEST,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_REQUEST],
    resizeObservables: [ADD_REQUEST],
  },
  {
    selector: ADD_REQUEST_INPUT,
    content: t("tour.shift-and-roster.add-request-input"),
    tourOpen: openAddRequestDialog,
    tourWaitFor: ADD_REQUEST_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_REQUEST_INPUT],
    resizeObservables: [ADD_REQUEST_INPUT],
  },
  {
    selector: EDIT_ITEM,
    content: t("tour.shift-and-roster.edit-item"),
    tourOpen: openClassicItemMenu,
    tourWaitFor: EDIT_ITEM,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EDIT_ITEM],
    resizeObservables: [EDIT_ITEM],
  },
  {
    selector: EDIT_ITEM_INPUT,
    content: t("tour.shift-and-roster.edit-item-input"),
    tourOpen: openEditItemDialog,
    tourWaitFor: EDIT_ITEM_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EDIT_ITEM_INPUT],
    resizeObservables: [EDIT_ITEM_INPUT],
  },
  {
    selector: DELETE_ITEM,
    content: t("tour.shift-and-roster.delete-item"),
    // Highlight MenuItem Delete → mở menu, không mở dialog
    tourOpen: openClassicItemMenu,
    tourWaitFor: DELETE_ITEM,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [DELETE_ITEM],
    resizeObservables: [DELETE_ITEM],
  },
  {
    selector: SHIFT_TAB,
    content: t("tour.shift-and-roster.shift"),
    tourOpen: goToShiftsTab,
    tourWaitFor: SHIFT_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: ADD_SHIFT_BTN,
    content: t("tour.shift-and-roster.add-shift-button"),
    tourOpen: goToShiftsTab,
    tourWaitFor: ADD_SHIFT_BTN,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP1,
    content: t("tour.shift-and-roster.add-shift-step1"),
    tourOpen: () => openAddShiftStep(0),
    tourWaitFor: ADD_SHIFT_STEP1,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_SHIFT_STEP1],
    resizeObservables: [ADD_SHIFT_STEP1],
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP1_NEXT,
    content: t("tour.shift-and-roster.add-shift-step1-next-button"),
    tourOpen: () => openAddShiftStep(0),
    tourWaitFor: ADD_SHIFT_STEP1_NEXT,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP2,
    content: t("tour.shift-and-roster.add-shift-step2"),
    tourOpen: () => openAddShiftStep(1),
    tourWaitFor: ADD_SHIFT_STEP2,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_SHIFT_STEP2],
    resizeObservables: [ADD_SHIFT_STEP2],
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP2_BREAK,
    content: t("tour.shift-and-roster.add-shift-step2-break-time"),
    tourOpen: () => openAddShiftStep(1),
    tourWaitFor: ADD_SHIFT_STEP2_BREAK,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP2_DOLATER,
    content: t("tour.shift-and-roster.add-shift-step2-do-later-button"),
    tourOpen: () => openAddShiftStep(1),
    tourWaitFor: ADD_SHIFT_STEP2_DOLATER,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP2_NEXT,
    content: t("tour.shift-and-roster.add-shift-step2-next-button"),
    tourOpen: () => openAddShiftStep(1),
    tourWaitFor: ADD_SHIFT_STEP2_NEXT,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP3,
    content: t("tour.shift-and-roster.add-shift-step3"),
    tourOpen: () => openAddShiftStep(2),
    tourWaitFor: ADD_SHIFT_STEP3,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_SHIFT_STEP3],
    resizeObservables: [ADD_SHIFT_STEP3],
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP3_DOLATER,
    content: t("tour.shift-and-roster.add-shift-step3-do-later-button"),
    tourOpen: () => openAddShiftStep(2),
    tourWaitFor: ADD_SHIFT_STEP3_DOLATER,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_STEP3_CONFIRM,
    content: t("tour.shift-and-roster.add-shift-step3-confirm-button"),
    tourOpen: () => openAddShiftStep(2),
    tourWaitFor: ADD_SHIFT_STEP3_CONFIRM,
    tourWaitFrames: 1,
    adminOnly: true,
  },
  {
    selector: ADD_SHIFT_TABLE,
    content: t("tour.shift-and-roster.add-shift-table"),
    tourOpen: showShiftTable,
    tourWaitFor: ADD_SHIFT_TABLE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
  {
    selector: ADD_SHIFT_EDIT,
    content: t("tour.shift-and-roster.add-shift-edit-button"),
    tourOpen: showShiftTable,
    tourWaitFor: ADD_SHIFT_EDIT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [ADD_SHIFT_EDIT],
    resizeObservables: [ADD_SHIFT_EDIT],
    adminOnly: true,
  },
  {
    selector: REQUEST_TAB,
    content: t("tour.shift-and-roster.request"),
    tourOpen: goToRequestTab,
    tourWaitFor: REQUEST_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: REQUEST_FILTER,
    content: t("tour.shift-and-roster.request-filter"),
    tourOpen: goToRequestTab,
    tourWaitFor: REQUEST_FILTER,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
  {
    selector: REQUEST_CALENDAR,
    content: t("tour.shift-and-roster.request-calendar"),
    tourOpen: goToRequestTab,
    tourWaitFor: REQUEST_CALENDAR,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [REQUEST_CALENDAR],
    resizeObservables: [REQUEST_CALENDAR],
  },
  {
    selector: REQUEST_CHART,
    content: t("tour.shift-and-roster.request-chart"),
    tourOpen: goToRequestTab,
    tourWaitFor: REQUEST_CHART,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [REQUEST_CHART],
    resizeObservables: [REQUEST_CHART],
  },
  {
    selector: REQUEST_TABLE,
    content: t("tour.shift-and-roster.request-table"),
    tourOpen: goToRequestTab,
    tourWaitFor: REQUEST_TABLE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
];

// Trả về steps theo hàm để hỗ trợ i18n
export const getShiftAndRosterTourSteps = (t, options = {}) => {
  const { isAdmin = true } = options;

  const commonStart = [
    {
      selector: '[data-tour="drawer-shift-and-roster-management"]',
      content: t("tour.shift-and-roster.drawer"),
    },
    {
      selector: ROSTER_TAB,
      content: t("tour.shift-and-roster.roster"),
      tourOpen: goToRosterTab,
      tourWaitFor: ROSTER_TAB,
      tourWaitFrames: 1,
      tourScrollBlock: "start",
    },
  ];

  // Roster card — đặt ngay trước DETAIL (sau delete roster)
  const rosterDataStep = {
    selector: ROSTER_DATA,
    content: t("tour.shift-and-roster.roster-data"),
    tourOpen: showRosterData,
    tourWaitFor: ROSTER_DATA,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [ROSTER_DATA],
    resizeObservables: [ROSTER_DATA],
  };

  // Employee: roster list → detail → filter → ô + → tab Shifts → bảng shift
  if (!isAdmin) {
    return [
      ...commonStart,
      rosterDataStep,
      {
        selector: DETAIL,
        content: t("tour.shift-and-roster.detail"),
        tourOpen: openRosterDetail,
        tourWaitFor: DETAIL,
        tourWaitFrames: 1,
        tourStableFrames: 2,
        mutationObservables: [DETAIL],
        resizeObservables: [DETAIL],
      },
      {
        selector: FILTER_INPUT,
        content: t("tour.shift-and-roster.filter-input"),
        tourOpen: openDetailToolbar,
        tourWaitFor: FILTER_INPUT,
        tourWaitFrames: 1,
      },
      // {
      //   selector: ADD_ROSTERITEM_TABLE,
      //   content: t("tour.shift-and-roster.add-rosteritem-table"),
      //   tourOpen: openAddCellPlus,
      //   tourWaitFor: ADD_ROSTERITEM_TABLE,
      //   tourWaitFrames: 1,
      //   tourStableFrames: 2,
      // },
      {
        selector: SHIFT_TAB,
        content: t("tour.shift-and-roster.shift"),
        tourOpen: goToShiftsTab,
        tourWaitFor: SHIFT_TAB,
        tourWaitFrames: 1,
        tourScrollBlock: "start",
      },
      {
        selector: ADD_SHIFT_TABLE,
        content: t("tour.shift-and-roster.add-shift-table"),
        tourOpen: showShiftTable,
        tourWaitFor: ADD_SHIFT_TABLE,
        tourWaitFrames: 1,
        tourStableFrames: 2,
      },
      {
        selector: REQUEST_TAB,
        content: t("tour.shift-and-roster.request"),
        tourOpen: goToRequestTab,
        tourWaitFor: REQUEST_TAB,
        tourWaitFrames: 1,
        tourScrollBlock: "start",
      },
      {
        selector: REQUEST_FILTER,
        content: t("tour.shift-and-roster.request-filter"),
        tourOpen: goToRequestTab,
        tourWaitFor: REQUEST_FILTER,
        tourWaitFrames: 1,
        tourStableFrames: 2,
      },
      {
        selector: REQUEST_CALENDAR,
        content: t("tour.shift-and-roster.request-calendar"),
        tourOpen: goToRequestTab,
        tourWaitFor: REQUEST_CALENDAR,
        tourWaitFrames: 1,
        tourStableFrames: 2,
        mutationObservables: [REQUEST_CALENDAR],
        resizeObservables: [REQUEST_CALENDAR],
      },
      {
        selector: REQUEST_CHART,
        content: t("tour.shift-and-roster.request-chart"),
        tourOpen: goToRequestTab,
        tourWaitFor: REQUEST_CHART,
        tourWaitFrames: 1,
        tourStableFrames: 2,
        mutationObservables: [REQUEST_CHART],
        resizeObservables: [REQUEST_CHART],
      },
      {
        selector: REQUEST_TABLE,
        content: t("tour.shift-and-roster.request-table"),
        tourOpen: goToRequestTab,
        tourWaitFor: REQUEST_TABLE,
        tourWaitFrames: 1,
        tourStableFrames: 2,
      },
    ];
  }

  const adminSteps = getAdminSteps(t).filter(
    (step) => !step.adminOnly || isAdmin
  );

  // Chèn roster-data + tách đúng sau delete-roster
  const deleteRosterIdx = adminSteps.findIndex(
    (s) => s.selector === DELETE_ROSTER
  );

  if (deleteRosterIdx === -1) {
    return [...commonStart, ...adminSteps, rosterDataStep];
  }

  const beforeDetail = adminSteps.slice(0, deleteRosterIdx + 1);
  const afterDelete = adminSteps.slice(deleteRosterIdx + 1);

  // afterDelete bắt đầu bằng DETAIL → giữ nguyên, chèn roster-data trước DETAIL
  return [
    ...commonStart,
    ...beforeDetail,
    rosterDataStep,
    ...afterDelete,
  ];
};
